import {$, w} from './constants';
$(function () {
    const $form = $('#form_tts');
    if (!$form.length) return;
    // Validación Formulario
    function showError(msg){
        $('#error_form').text(msg).show();
    }
    function clearError(){
        $('#error_form').text('').hide();
    }
    $form.validate({
        ignore: [],
        rules: {
            name: { required: true },
            lastname: { required: true },
            mail: { required: true, email: true },
        },
        messages: {
            name: "Este campo es obligatorio.",
            lastname: "Este campo es obligatorio.",
            mail: {
                required: "Este campo es obligatorio.",
                email: "Email inválido."
            }
        },
        errorElement: "p",
        errorClass: "form-error",
        highlight: function (element) {
            $(element).addClass('is-error');
        },
        unhighlight: function (element) {
            $(element).removeClass('is-error');
        },
        errorPlacement: function (error, element) {
            error.insertAfter(element);
        },
        submitHandler: function (formEl, event) {
            event.preventDefault();
            clearError();
            const $btn = $('#form_tts_submit');
            $.ajax({
                url: cltvo_js_vars.ajax_url,
                method: 'POST',
                dataType: 'json',
                data: {
                    action: 'form',
                    nonce: cltvo_js_vars.form_nonce,
                    name: $('#name').val(),
                    lastname: $('#lastname').val(),
                    mail: $('#mail').val(),
                }
            })
            .done(function(res){
                if (!res || !res.message) {
                    showError('Respuesta inválida del servidor.');
                    return;
                }
                $form.fadeOut(100);
                setTimeout(()=>{
                    $('#form_success').fadeIn(150);
                }, 100)
            })
            .fail(function(xhr){
                const msg = (xhr.responseJSON && xhr.responseJSON.message)
                || xhr.responseText
                || 'Error al guardar.';
                showError(msg);
            })
            .always(function(){
                $btn.prop('disabled', false).removeClass('is-loading');
            });

            return false;
            }
    });
});